import { render, staticRenderFns } from "./TextTruncatedChip.vue?vue&type=template&id=49080870&scoped=true"
import script from "./TextTruncatedChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextTruncatedChip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49080870",
  null
  
)

export default component.exports